import request from "@/utils/request";

export default function agentRefundParkingOrder(id) {
  return request.get(`/fund/parkingRecord/agentRefundParkingOrder/${id}`);
}
